import React from 'react';

export function ShowAddressAndLink({ selectedStore }) {
    return (
        <>
            <div>
                <strong>Selected location address:</strong>
                &nbsp;
                <br className="d-lg-none" />
                <span className="d-block d-md-inline">
                    {selectedStore.store.address}, <br className="d-sm-none" />
                    {selectedStore.store.addressCity === ''
                        ? selectedStore.store.marketingCity
                        : selectedStore.store.addressCity}
                    ,&nbsp;
                    {selectedStore.store.stateAbbrev}&nbsp;{selectedStore.store.zipCode}
                </span>
            </div>
            <div className="my-2">
                <a href={selectedStore.store.urlPath} className="milan-text-navy p-link">
                    Learn more about Milan Laser {selectedStore.metro.name}
                </a>
            </div>
        </>
    );
}

export default ShowAddressAndLink;
